import superagent from 'superagent'

export const linesSet = lines => ({
  type: 'LINES_SET',
  payload: lines
})

export const lineCreate = line => ({
  type: 'LINE_CREATE',
  payload: line
})

export const lineUpdate = line => ({
  type: 'LINE_UPDATE',
  payload: line
})

export const lineDelete = id => ({
  type: 'LINE_DELETE',
  payload: id
})

const callChanges = (page, token, lines = []) => {
  const testDate = '2000-01-01T00:00:00.000Z'
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI_2__}/changes/get?activityId=1&asOfDate=${testDate}&page=${page}&pageSize=100&includeDeletedContent=false`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        // dispatch(setChangesLastCalled())
        if (res.body.measurements.length === 0) {
          resolve(lines)
        } else {
          const pageLines = res.body.measurements.filter(measure => measure.measurementTypeId === 4)
          const lineArr = lines.concat(pageLines)
          resolve(callChanges(page + 1, token, lineArr))
        }
      })
  })
}

export const lineFetchRequest = () => (dispatch, getState, token) => {
  return new Promise(resolve => {
    callChanges(0, token, [])
      .then(res => {
        res.map(s => {
          if (s.photoId) {
            $.ajax({
              method: 'GET',
              url: `${__API_URI__}/photo/get/${s.photoId}`,
              headers: {
                Authorization: `Bearer ${token}`,
                Platform: 'Web',
                Version: `${__version__}`
              }
            }).done(res => {
              s.photo = res
            })
          }
        })
        dispatch(linesSet(res))
        resolve(res)
      })
  })
}

// export const lineFetchRequest = () => (dispatch, getState, token) => {
//   return new Promise(resolve => {
//     superagent
//       .get(`${__API_URI__}/measurement/get?activityId=1&measurementType=4&includeJson=false`)
//       .set('Authorization', `Bearer ${token}`)
//       .set('Content-Type', 'application/json')
//       .set('Platform', 'Web')
//       .set('Version', '2.0.5')
//       .end((err, res) => {
//         if (err) {
//           if (err.status == 401) {
//             return err.status
//           }
//         }
//         res.body.map(s => {
//           if (s.photoId) {
//             $.ajax({
//               method: 'GET',
//               url: `${__API_URI__}/photo/get/${s.photoId}`,
//               headers: {
//                 Authorization: `Bearer ${token}`,
//                 Platform: 'Web',
//                 Version: '2.0.5'
//               }
//             }).done(res => {
//               s.photo = res
//             })
//           }
//         })
//         resolve(res.body)
//         dispatch(linesSet(res.body))
//       })
//   })
// }

export const lineCreateRequest = lineObj => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .post(`${__API_URI__}/measurement/create`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(lineObj))
      .end((err, res) => {
        if (err) {
          reject(err);
          if (err.status == 401) {
            return err.status;
          }
        }
        Countly.q.push([
          'add_event',
          {
            key: 'Create Line',
            count: 1,
          },
        ]);

        if (res.body.photoId) {
          // Fetch photo details based on photoId
          $.ajax({
            method: 'GET',
            url: `${__API_URI__}/photo/get/${res.body.photoId}`,
            headers: {
              Authorization: `Bearer ${token}`,
              Platform: 'Web',
              Version: `${__version__}`,
            },
          })
            .done((photoRes) => {
              // Add the photo data to the main response body
              res.body.photo = photoRes;

              // Dispatch the circle creation with the updated payload
              dispatch(lineCreate(res.body));
              resolve(res.body);
            })
            .fail((ajaxErr) => {
              console.error('Error fetching photo details:', ajaxErr);
              reject(ajaxErr);
            });
        } else {
          // Directly dispatch if no photoId is present
          dispatch(lineCreate(res.body));
          resolve(res.body);
        }
      });
  })
}

export const lineUpdateRequest = lineObj => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .put(`${__API_URI__}/measurement/update`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(lineObj))
      .end((err, res) => {
        if (err) {
          reject(err)
          if (err.status == 401) {
            return err.status
          }
        } else {
          if (res.photoId) {
            $.ajax({
              method: 'GET',
              url: `${__API_URI__}/photo/get/${res.photoId}`,
              headers: {
                Authorization: `Bearer ${token}`,
                Platform: 'Web',
                Version: `${__version__}`
              }
            }).done(res => {
              res.photo = res
            })
          }
          dispatch(lineUpdate(res.body))
        }
        resolve(res.body)
      })
  })
}

export const lineDeleteRequest = id => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .delete(`${__API_URI__}/measurement/delete/${id}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          if (err.status == 401) {
            return err.status
          }
        }
        resolve(res.body)
        dispatch(lineDelete(id))
      })
  })
}
